import fuzzysort from 'fuzzysort'
import {
  type Ref,
  computed,
  shallowRef,
  onMounted,
  ref,
  watch,
  watchEffect,
} from 'vue'
import cancellablePromiseProxy from '@aspectus/cancellable-promise-proxy'
import { useLoadable } from '@/packages/vue-loading-state'

export default function useFuzzySort(
  resource,
  dependencyKey?: string,
  dependency?: Ref<Record<string, any>> | undefined,
  dependencyResolver?
) {
  const limit = 100
  let offset = 0
  const list = shallowRef([])
  const resultList = shallowRef([])
  let allList = []
  const lengthResult = computed(() => list.value.length)

  const { load, loading, result } = useLoadable(getList)

  if (undefined !== dependency) {
    watch(
      dependency,
      () => {
        if (
          (dependencyResolver && dependencyResolver(dependency)) ||
          (!dependencyResolver && dependency)
        ) {
          resultList.value = []
          load([
            dependency && dependencyKey
              ? {
                  [dependencyKey]: dependencyResolver
                    ? dependencyResolver(dependency)
                    : dependency,
                }
              : undefined,
          ])
        }
      },
      { immediate: true }
    )
  }

  function search(query: string) {
    offset = 0
    const fuzzySortList = fuzzysort.go(query, allList, {
      threshold: -1000,
      // limit: 500,
      all: true,
      key: 'title',
      // scoreFn: a => Math.max(a[0]?a[0].score:-1000, a[1]?a[1].score-100:-1000),
    })
    list.value = (fuzzySortList || []).map(({ obj }) => obj)
    resultList.value = list.value.slice(0, limit)
  }

  function getList(args) {
    const cancelController = new AbortController()
    const cancellableResource = resource.config(
      'signal',
      cancelController.signal
    )
    const request = cancellablePromiseProxy(
      new Promise((resolve, reject) => {
        cancellableResource.execute(...args).then(resolve, reject)
      }),
      { cancelController }
    )
      .then(({ items }) => {
        allList = items
        search('')
      })
      .catch((err) => (err.name == 'AbortError' ? [] : err))
    return request
  }

  // function load(d?) {
  //   loading.value = true
  //   resource
  //     .execute(
  //       d && dependencyKey
  //         ? { [dependencyKey]: dependencyResolver ? dependencyResolver(d) : d }
  //         : undefined
  //     )
  //     .then(({ items }) => {
  //       allList = items
  //       search('')
  //     })
  //     .finally(() => {
  //       loading.value = false
  //     })
  // }
  function getPaginated(arg) {
    const start = (offset += limit)
    const end = offset + limit
    if (start <= lengthResult.value) {
      // loading.value = true
      resultList.value = [...resultList.value, ...list.value.slice(start, end)]
      // loading.value = false
    }
  }

  onMounted(() => {
    if (!dependency) {
      load([])
    }
  })

  return {
    loading,
    list,
    resultList,
    load: (v) => load([v]),
    getPaginated,
    search,
  }
}
